(() => {
  if (window.BestekPressRecognition) { window.BestekPressRecognition.init(); return; }
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const ribbon = root.querySelector('.bestek-press__ribbon');
    const track = ribbon.querySelector('.bestek-press__track');
    const set = track.firstElementChild;
    const button = root.querySelector('.bestek-press__motion-control');
    const controller = new AbortController();
    const on = (target,event,handler,options={}) => target.addEventListener(event,handler,{...options,signal:controller.signal});
    const gallery = root.querySelector('.bestek-press__features');
    const pages = [...gallery.querySelectorAll('.bestek-press__feature')];
    function openPage(page) { pages.forEach(p=>p.classList.toggle('is-open',p===page)); }
    gallery.classList.add('is-enhanced');
    openPage(pages[0]);
    pages.forEach(page=>{
      on(page,'pointerenter',e=>{if(e.pointerType!=='touch')openPage(page);});
      on(page,'focus',()=>openPage(page));
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = false, hovered = false, drag = null, suppress = false, visible = false, previous = 0, frame = 0, offset = 0, cycle = 0, destroyed = false;
    on(ribbon,'pointerenter',e=>{if(e.pointerType==='mouse'){hovered=true;syncAnimation();}});
    on(ribbon,'pointerleave',()=>{hovered=false;syncAnimation();});
    for (let i=0;i<2;i++) {
      const clone = set.cloneNode(true);
      clone.dataset.clone = 'true';
      clone.setAttribute('aria-hidden','true');
      clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);
      track.appendChild(clone);
    }
    function measure() { cycle=set.getBoundingClientRect().width; }
    const resize = new ResizeObserver(measure); resize.observe(set); measure();
    const observer = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;syncAnimation();}); observer.observe(ribbon);
    function render() {if(cycle){offset=((offset%cycle)+cycle)%cycle;ribbon.scrollLeft=offset;}}
    function pause() {paused=!paused;button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Resume media motion':'Pause media motion';syncAnimation();}
    on(button,'click',pause);
    on(ribbon,'dragstart',e=>e.preventDefault());
    on(ribbon,'pointerdown',e=>{if(e.button!==0)return;drag={id:e.pointerId,x:e.clientX,y:e.clientY,start:ribbon.scrollLeft,moved:false};suppress=false;syncAnimation();});
    on(ribbon,'pointermove',e=>{
      if(!drag||drag.id!==e.pointerId)return;
      const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
      if(!drag.moved&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>8){drag=null;syncAnimation();return;}
      if(Math.abs(dx)>6){drag.moved=true;suppress=true;ribbon.setPointerCapture(e.pointerId);ribbon.classList.add('is-dragging');offset=drag.start-dx;render();}
    });
    function release(e) {if(!drag)return;if(ribbon.hasPointerCapture(e.pointerId))ribbon.releasePointerCapture(e.pointerId);drag=null;ribbon.classList.remove('is-dragging');syncAnimation();setTimeout(()=>suppress=false,0);}
    on(ribbon,'pointerup',release);on(ribbon,'pointercancel',release);
    on(ribbon,'click',e=>{if(suppress){e.preventDefault();e.stopPropagation();}},{capture:true});
    on(ribbon,'keydown',e=>{
      if(e.code==='Space'){e.preventDefault();pause();}
      if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();offset=ribbon.scrollLeft+(e.key==='ArrowRight'?240:-240);render();}
    });
    on(ribbon,'wheel',e=>{if(Math.abs(e.deltaX)>Math.abs(e.deltaY)){e.preventDefault();offset=ribbon.scrollLeft+e.deltaX;render();}},{passive:false});
    on(ribbon,'focusin',e=>{if(e.target.matches('a'))offset=ribbon.scrollLeft;syncAnimation();});
    on(ribbon,'focusout',()=>queueMicrotask(syncAnimation));
    on(document,'visibilitychange',syncAnimation);
    on(reduced,'change',syncAnimation);
    function shouldAnimate() {
      if(destroyed||!visible||paused||hovered||reduced.matches||drag||document.hidden) return false;
      return !(ribbon.contains(document.activeElement)&&document.activeElement.matches(':focus-visible'));
    }
    function syncAnimation() {
      if(shouldAnimate()) {
        if(!frame) {previous=0;frame=requestAnimationFrame(animate);}
      } else {
        if(frame) cancelAnimationFrame(frame);
        frame=0;previous=0;
      }
    }
    function animate(now) {
      frame=0;
      if(!shouldAnimate()) {previous=0;return;}
      const dt=previous?Math.min(now-previous,50):0;previous=now;
      offset+=dt*.026;render();
      frame=requestAnimationFrame(animate);
    }
    syncAnimation();
    instances.set(root,()=>{destroyed=true;cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();controller.abort();track.querySelectorAll('[data-clone]').forEach(c=>c.remove());});
  }
  function init() {document.querySelectorAll('[data-bestek-press]').forEach(mount);}
  window.BestekPressRecognition={init};
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{instances.forEach((destroy,root)=>{if(e.target.contains(root)){destroy();instances.delete(root);}});});
  init();
})();
